import React, { ReactNode, useLayoutEffect } from 'react'
import { ChatboxPosition, Crisp } from 'crisp-sdk-web'

import { InjectionTokens } from '@/controller/tokens'

import { AuthState } from '@/domain/states/AuthState'

import { useInjection } from '@/presentation/contexts/InjectionContext'
import { appZIndex } from '@/presentation/utils/zIndexMapper'

function ChatPresenter(): ReactNode {
  const authState = useInjection<AuthState>(InjectionTokens.AuthState)

  useLayoutEffect(() => {
    const auth = authState.getStateSnapshot()

    if (!auth?.user) {
      return
    }

    Crisp.configure(import.meta.env.VITE_CRISP_WEBSITE_ID, {
      autoload: false
    })
    Crisp.setZIndex(appZIndex.CHAT)

    Crisp.user.setEmail(auth.user.email)
    Crisp.user.setNickname([auth.user.name, auth.user.surname].filter(Boolean).join(' '))

    // O usuário do Account não traz mais os dados de assinatura (status, plano, forma de pagamento),
    // então eles e os eventos de assinatura (`enter-paid`, `enter-boleto`...) deixaram de ir ao Crisp.
    // O Crisp descarta em silêncio o que não for string, number ou boolean: datas vão como ISO.
    Crisp.session.setData({
      pilot: auth.user.pilot ? 'Piloto' : 'Não piloto',
      aviation_segment: auth.user.segment,
      aircraft_type: auth.user.aircraftType,
      confirmed_email: auth.user.isEmailVerified,
      trial_to: auth.user.trialTo?.toISOString()
    })

    // Sem `setTokenId`: ele usava o `salt` do usuário legado, que o Account não expõe, e o token da
    // sessão do Crisp precisa ser secreto (com o id do usuário, qualquer um leria o histórico alheio).
    // Sem ele o Crisp mantém a conversa pelo próprio cookie, só não sincroniza entre dispositivos.
    Crisp.load()
  }, [])

  return null
}

export { ChatPresenter }
